/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export abstract class WinPresentationController {

    public readonly moduleName:string;  // This name is only for dev logging.
    protected _skippable:boolean;
    protected _flowStateController:FlowStateController;

    constructor(name:string, skippable:boolean) {
        this.moduleName = name;
        this._skippable = skippable;
        if(skippable && !this.skip) {
            debugger;
            throw new Error(`${this.moduleName} must implement skip() when skippable!`);
        }
    }

    public async start(flowStateController:FlowStateController):Promise<void> {
        this._flowStateController = flowStateController;
        if(this._skippable) {
            flowStateController.setSkipCallback(() => this.skip!());
        } else {
            flowStateController.setSkipCallback();
        }

        if(this.hasWin()) {
            await this.createWinAnimation();
        } else {
            return Promise.resolve();
        }
    }

    public reset?():void;

    protected skip?():void;

    protected abstract hasWin():boolean;

    protected abstract createWinAnimation():Promise<void>;
}